module.exports = __webpack_public_path__ + "img/2X2_8.5686bc68.jpg";